<template>
  <div class="container"><slot></slot></div>
</template>

<script>

  export default {
    name: 'Container'
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  .container {
    @include container;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/container.vue